import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'

export interface SearchStats {
  total_searches?: number
  successful_searches?: number
  success_rate?: number
  avg_duration_ms?: number | null
  searches_by_hour?: Record<string, number>
  searches_by_dow?: Record<string, number>
  searches_by_day?: Array<{ date: string; count: number }>
  days?: number
  account_name?: string | null
}

export interface VehicleStats {
  total_requests?: number
  requests_by_status?: Record<string, number>
  top_actions?: Array<{ action: string; count: number }>
  unique_accounts?: number
  avg_response_time_ms?: number | null
  total_bookings?: number
  successful_bookings?: number
  days?: number
  account_name?: string | null
}

export function useSearchStats(
  days: number = 30,
  accountName?: string,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: queryKeys.analytics.searchStats(days, accountName),
    queryFn: async () => {
      const resp = await client.GET('/api/v1/analytics/search-stats', {
        params: {
          query: { days, account_name: accountName ?? undefined },
        },
      })
      return resp.data as SearchStats
    },
    enabled,
  })
}

export function useVehicleStats(
  days: number = 30,
  accountName?: string,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: queryKeys.analytics.vehicleStats(days, accountName),
    queryFn: async () => {
      const resp = await client.GET('/api/v1/analytics/vehicle-stats', {
        params: {
          query: { days, account_name: accountName ?? undefined },
        },
      })
      return resp.data as VehicleStats
    },
    enabled,
  })
}
